module.exports = __webpack_public_path__ + "static/media/Minnesota_Wild.712753b6.svg";